import { KdsDatePicker } from "@kazaar-platform/design-system";
import { Controller, useFormContext } from "react-hook-form";
import { calendarDateToUTC } from "@/helpers/dates";
import { type ControlledDatePickerProps } from "./ControlledDatePicker.types";

const ControlledDatePicker = ({
  name,
  ...inputProps
}: ControlledDatePickerProps) => {
  const { control, formState } = useFormContext();

  const error = formState.errors[name];

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <KdsDatePicker
          {...inputProps}
          errorMessage={error?.message?.toString()}
          hasError={!!error}
          label={inputProps.label}
          onChange={(value) => {
            field.onChange(value ? calendarDateToUTC(value) : undefined);
          }}
        />
      )}
    />
  );
};

export { ControlledDatePicker };
